"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4349],{

/***/ 4847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useImageDataHandler; }
/* harmony export */ });
/* unused harmony export imageDataHandler */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9366);
/* harmony import */ var _util_magnolia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7581);
/* harmony import */ var _util_viewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5625);





/**
 * Hook to generate an image handler function.
 *
 * Options can be passed to handler function to optimise image size.
 * If the image does not to bigger than "sm" in any viewport, then
 * `maxViewport` option should be set to `Viewport.sm`.
 *
 * Image sizes (width) for each viewport size:
 * - xs: 600px
 * - sm: 800px
 * - md: 900px
 * - lg: 1024px
 * - xl: 1440px
 */ function useImageDataHandler() {
    var isPreview = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().isPreview;
    var viewport = (0,_contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().viewport;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(image, options) {
        return imageDataHandler(image, viewport, isPreview, options);
    }, [
        isPreview,
        viewport
    ]);
}
/**
 * Get image information from MGNL (MGNL = Magnolia)
 * @param image - Image object from MGNL
 * @param viewport - Viewport from store
 * @returns Object containing "imageSrc" (image url), "imageLoader" (loader to handle next/image)
 *  and boolean "fallback", to show a fallback image if current image is not published in MGNL
 */ function imageDataHandler(image, viewport) {
    var isPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, options = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof image === "string" || !image) return {
        src: "",
        width: 0,
        height: 0,
        imageLoader: undefined,
        imageSrc: ""
    };
    var _metadata = image.metadata, width = _metadata.width, height = _metadata.height;
    var src = (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image["@link"], isPreview).toString();
    var optimisedViewport = (0,_util_viewport__WEBPACK_IMPORTED_MODULE_4__/* .optimiseViewport */ .s)(viewport, options);
    var imageLoader = function() {
        var ref;
        return optimisedViewport && ((ref = image.renditions) === null || ref === void 0 ? void 0 : ref[optimisedViewport].link) ? (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image.renditions[optimisedViewport].link, isPreview) : src;
    };
    return {
        src: src,
        width: width,
        height: height,
        imageLoader: imageLoader,
        imageSrc: src
    };
}


/***/ }),

/***/ 4349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Hero; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-eec2778c.mjs
var Button_eec2778c = __webpack_require__(9358);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-460da2fc.mjs
var Link_460da2fc = __webpack_require__(1607);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useKeyDown-88662051.mjs
var useKeyDown_88662051 = __webpack_require__(403);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Video-83c15c06.mjs
var Video_83c15c06 = __webpack_require__(2645);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-be3826ec.mjs
var Image_be3826ec = __webpack_require__(567);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Hero.js






const W = "mouse", k = "mouse__icon", w = "mouse__wheel", x = "wheelUpDown", a = {
  mouse: W,
  mouseIcon: k,
  mouseWheel: w,
  wheelUpDown: x
};
function A() {
  return /* @__PURE__ */ react.createElement("div", { className: a.mouse }, /* @__PURE__ */ react.createElement("div", { className: a.mouseIcon }, /* @__PURE__ */ react.createElement("span", { className: a.mouseWheel })));
}
const S = "hero", v = "hero__block-auto", O = "hero__wrapper", P = "hero__overlay", b = "hero__content", C = "desktop", I = "hero__buttons", L = "hero__title", V = "hero__title--lead-text", H = "hero--align-bottom", R = "hero__scroll-wheel", t = {
  hero: S,
  heroBlockAuto: v,
  heroWrapper: O,
  heroOverlay: P,
  heroContent: b,
  desktop: C,
  heroButtons: I,
  heroTitle: L,
  heroTitleLeadText: V,
  heroAlignBottom: H,
  heroScrollWheel: R
};
function G({
  heading: u,
  leadText: c,
  imageAltText: h,
  videoAltText: m,
  buttons: _,
  video: o,
  assetType: l,
  imageData: r,
  viewport: n,
  credits: i
}) {
  const E = Array.isArray(o) ? o.find((N) => n && N.device?.includes(n)) : o, g = (l === "image" ? [h, i] : [m, E?.credits]).filter(Boolean).join(" - ");
  return /* @__PURE__ */ react.createElement(
    useClickOutside_55c64a80.B,
    {
      topPadding: useClickOutside_55c64a80.B.Padding.NONE,
      bottomPadding: useClickOutside_55c64a80.B.Padding.NONE,
      "data-testid": "hero-block"
    },
    /* @__PURE__ */ react.createElement(
      "div",
      {
        className: t.hero,
        "data-testid": "hero",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      l === "image" && r && /* @__PURE__ */ react.createElement(
        Image_be3826ec.I,
        {
          credits: i,
          src: r.imageSrc,
          width: r.width,
          height: r.height,
          altText: h ?? "",
          imageLoader: r.imageLoader,
          styling: Image_be3826ec.a.HERO
        }
      ),
      o && l === "video" && /* @__PURE__ */ react.createElement(
        Video_83c15c06.V,
        {
          title: m ?? "",
          autoplay: !0,
          videoType: "asset",
          video: o,
          styling: Video_83c15c06.a.HERO,
          viewport: n
        }
      ),
      /* @__PURE__ */ react.createElement("div", { className: t.heroOverlay, title: g }),
      /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { className: t.heroBlockAuto }, /* @__PURE__ */ react.createElement("div", { className: t.heroWrapper }, /* @__PURE__ */ react.createElement("div", { className: t.heroContent }, /* @__PURE__ */ react.createElement(
        "h1",
        {
          className: (0,useKeyDown_88662051.c)(useKeyDown_88662051.t.heroText, t.heroTitle),
          itemProp: "name"
        },
        u
      ), c && /* @__PURE__ */ react.createElement(
        "p",
        {
          className: (0,useKeyDown_88662051.c)(
            useKeyDown_88662051.t.textsLeadText,
            t.heroTitle,
            t.heroTitleLeadText
          ),
          itemProp: "description"
        },
        c
      ), /* @__PURE__ */ react.createElement(
        "span",
        {
          className: t.heroButtons,
          "data-testid": "hero-button-container",
          itemProp: "description"
        },
        _
      )))),
      /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { className: t.heroAlignBottom }, /* @__PURE__ */ react.createElement("div", { className: t.heroScrollWheel }, /* @__PURE__ */ react.createElement(A, null)))
    )
  );
}

//# sourceMappingURL=Hero.js.map

// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Hero/Hero.tsx










function Hero(param) {
    var heading = param.heading, leadText = param.leadText, asset = param.asset, buttons = param.buttons;
    var ref;
    var router = (0,next_router.useRouter)();
    var viewport = (0,ViewportContext/* default */.Z)().viewport;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var HeroButton = isEmployerSite ? Button_eec2778c.B.HeroEmployer : Button_eec2778c.B.HeroTalents;
    var buttonObjects = (0,magnolia/* jcrMultiFieldToArray */.FE)(buttons);
    var buttonLinks = buttonObjects.map(function(button) {
        var link = (0,magnolia/* formatPageLink */.Jd)(button.link, router === null || router === void 0 ? void 0 : router.isPreview, button.anchorTag);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_460da2fc.L, {
            className: Button_eec2778c.B.DefaultFocusStyleInLink,
            href: link,
            disableLinkTextStyle: true,
            itemProp: "url",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroButton, {
                asDiv: true,
                text: button.text
            })
        }, button.text);
    });
    if (asset.field === "video") {
        var ref1, ref2, ref3, ref4, ref5, ref6;
        var videoXS = asset.videoXS, videoSM = asset.videoSM, videoLG = asset.videoLG, videoAltText = asset.videoAltText;
        var videoSrc = [
            {
                src: (0,magnolia/* getAssetPath */.K3)(videoXS, router.isPreview),
                mimeType: (ref1 = videoXS.metadata) === null || ref1 === void 0 ? void 0 : ref1.mimeType,
                device: [
                    "xs"
                ],
                credits: videoXS === null || videoXS === void 0 ? void 0 : (ref2 = videoXS.metadata) === null || ref2 === void 0 ? void 0 : ref2.rights
            },
            {
                src: (0,magnolia/* getAssetPath */.K3)(videoSM, router.isPreview),
                mimeType: (ref3 = videoSM.metadata) === null || ref3 === void 0 ? void 0 : ref3.mimeType,
                device: [
                    "sm",
                    "md"
                ],
                credits: videoSM === null || videoSM === void 0 ? void 0 : (ref4 = videoSM.metadata) === null || ref4 === void 0 ? void 0 : ref4.rights
            },
            {
                src: (0,magnolia/* getAssetPath */.K3)(videoLG, router.isPreview),
                mimeType: (ref5 = videoLG.metadata) === null || ref5 === void 0 ? void 0 : ref5.mimeType,
                device: [
                    "lg",
                    "xl"
                ],
                credits: videoLG === null || videoLG === void 0 ? void 0 : (ref6 = videoLG.metadata) === null || ref6 === void 0 ? void 0 : ref6.rights
            }, 
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(G, {
                assetType: asset.field,
                heading: heading,
                leadText: leadText,
                video: videoSrc,
                viewport: viewport,
                videoAltText: videoAltText,
                buttons: buttonLinks
            })
        });
    }
    var image = asset.image, imageAltText = asset.imageAltText;
    var imageData = imageDataHandler(image);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(G, {
            imageData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
                imageSrc: imageData.src
            }),
            assetType: asset.field,
            heading: heading,
            leadText: leadText,
            imageAltText: imageAltText,
            buttons: buttonLinks,
            credits: image === null || image === void 0 ? void 0 : (ref = image.metadata) === null || ref === void 0 ? void 0 : ref.rights
        })
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/Hero/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 2645:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ h; },
/* harmony export */   "a": function() { return /* binding */ C; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7720);



const A = "video", f = "video__hero", g = "video__article", k = "desktop", P = "video__caption", d = {
  video: A,
  videoHero: f,
  videoArticle: g,
  desktop: k,
  videoCaption: P
};
var C = /* @__PURE__ */ ((t) => (t.ARTICLE = "videoArticle", t.HERO = "videoHero", t))(C || {});
function h({
  title: t,
  caption: s,
  styling: i,
  autoplay: l,
  embed: o,
  image: u = "",
  videoType: c,
  video: r,
  viewport: m
}) {
  const E = Array.isArray(r) ? r.find((y) => m && y.device?.includes(m)) : r, a = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(d.video, i && d[i]), p = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, c === "icareusIframe" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ), c === "embed" && (o?.includes("iframe") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-embed",
      itemProp: "video",
      title: t,
      className: a,
      src: o,
      playsInline: !0,
      controls: !0
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )), c === "asset" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset",
      itemProp: "video",
      title: t,
      className: a,
      src: E?.src,
      autoPlay: l,
      loop: !0,
      muted: !0,
      playsInline: !0
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset-control",
      itemProp: "video",
      title: t,
      className: a,
      controls: !0,
      poster: u,
      playsInline: !0
    },
    !Array.isArray(r) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: r.src, type: r.mimeType }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )));
  return i === "videoArticle" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      bottomPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.LARGE,
      "data-testid": "article-video"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content, { "data-testid": "article-video-content" }, p, s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsCaption, d.videoCaption) }, s))
  )) : p;
}

//# sourceMappingURL=Video-83c15c06.mjs.map


/***/ })

}]);